import { defineMessages } from 'react-intl';

export default defineMessages({
  preferred_dishes_title: {
    id:
      'app.modules.shopDetails.PreferredDishes.PreferredDishesSwimlane.preferredDishesTitle',
    defaultMessage: 'Volvé a pedirlos',
  },
});
